import { Injectable } from '@angular/core';
import toastr from 'toastr';
import Swal, { SweetAlertIcon } from 'sweetalert2';

export enum TypeMessage {
	SUCCESS = 'success',
	ERROR = 'error',
	WARNING = 'warning',
	INFO = 'info',
	QUESTION = 'question',
}

export enum TypeActionMessage {
	REGISTRAR = 'I',
	MODIFICAR = 'U',
	ELIMINAR = 'D',
	COPIAR = 'C',
}

export enum DefaultMessageText {
	ACEPTAR = 'Aceptar',
	CONTINUAR = 'Si, Continuar',
	CANCELAR = 'No, Cancelar',
	CARCANGDO = 'Cargando...!',
	VALIDANDO = 'Validando...!',
	BEFORE_CLOSE_PAGE_TITLE = '¿Estas seguro que quieres salir del sitio web?',
	BEFORE_CLOSE_PAGE_MESSAGE = 'Es posible que los datos ingresados no se guarden.',
	ERROR = '¡ERROR!',
	SUCCESS = '¡Bien hecho!',
	INFO = '¡Atento!',
	WARNING = '¡ADVERTENCIA!',
}
export enum ToastrPosition {
	BOTTON_RIGHT = 'toast-bottom-right',
}

@Injectable({
	providedIn: 'root',
})
export class MessageUtilService {
	message = '';
	constructor() {}

	getMessageError(codigo: string, element: string = '', message?: string) {
		// tslint:disable: indent
		switch (codigo) {
			case 'A001':
				this.message = `El campo ${element}  es requerido`;
				break;
			case 'A002':
				this.message = `El campo ${element} no cumple con el formato establecido`;
				break;
			case 'A003':
				this.message = `La fecha ingresada no puede ser superior a la fecha del dí­a actual`;
				break;
			case 'A004':
				this.message = `La fecha del documento no puede ser menor a la fecha del ultimo documento ingresado`;
				break;
			case '000046':
				this.message = `${message}`;
				break;
			case 'A005':
				this.message = `No ha ingresado la serie`;
				break;
			case 'A006':
				this.message = `La fecha ingresada no puede ser menor a la fecha del dí­a actual`;
				break;
			case 'A999':
				this.message = `${element}`;
				element = 'Error';
				// return toastr.error(this.message);
				break;
			case '500':
				this.message = `Por favor comuniquese con el soporte del Sistema`;
				break;
			default:
				this.message = element;
				break;
		}
		toastr.options = {
			positionClass: 'toast-bottom-right',
			closeButton: true,
			progressBar: true,
			newestOnTop: true,
		};
		toastr['error'](this.message, `<h5 class='text-white'> ${element} </h5>`);
		return toastr;
	}

	getAlertWarning(mensaje: string, title = '¡Advertencia!') {
		toastr.options = {
			positionClass: 'toast-bottom-right',
			closeButton: true,
			progressBar: true,
			newestOnTop: true,
		};
		toastr['warning'](mensaje, `<h5 class='text-white'> ${title} </h5>`);
		return toastr;
	}

	getMessageWarning(title: string = '', mensaje: string = '', focusCancel = false) {
		/* const swalWithBootstrapButtons = Swal.mixin({
			customClass: {
				confirmButton: 'btn btn-success',
				cancelButton: 'btn btn-danger'
			},
			buttonsStyling: false
		}) */
		return Swal.fire({
			title: title,
			html: mensaje,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#0abb87',
			cancelButtonColor: '#fd397a',
			confirmButtonText: 'Si',
			cancelButtonText: 'No',
			allowOutsideClick: false,
			//reverseButtons: true
			focusCancel: true,
		});
	}

	getMessageWarningCancel(title: string = '', mensaje: string = '') {
		return Swal.fire({
			title: title,
			html: mensaje,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#0abb87',
			cancelButtonColor: '#fd397a',
			confirmButtonText: 'Si',
			cancelButtonText: 'No',
			allowOutsideClick: false,
			focusCancel: true,
		});
	}

	getMessageWarningOK(title: string = '', mensaje: string = '') {
		return Swal.fire({
			title: title,
			html: mensaje,
			icon: 'warning',
			confirmButtonColor: '#3085d6',
			confirmButtonText: 'OK',
			allowOutsideClick: false,
			focusCancel: true,
		});
	}

	getPersonalConfirmMessage(type, title, position, message) {
		toastr[type](`${title}<br /><br />
			${message}
		<br /><br />
		<button type='button' class='btn btn-success'>Continuar</button>`);
		toastr.options = {
			positionClass: `toast-${position}`,
			preventDuplicates: true,
			tapToDismiss: false,
		};
		return toastr;
	}

	getMessageQuestion(title: string, html?: string) {
		return Swal.fire({
			icon: 'question',
			title: title,
			//text: mensaje,
			showCancelButton: true,
			confirmButtonColor: '#0abb87',
			cancelButtonColor: '#fd397a',
			confirmButtonText: 'Sí',
			cancelButtonText: 'No',
			html: html,
			// focusCancel: true
			onOpen: () => Swal.getCancelButton()?.focus(),
		});
	}

	//margin: 2rem 0 0 0;
	getMessageQuestionHtml(title: string, mensaje?: string) {
		let texto = `<h2 style="font-weight: 500; font-size: 1.3rem; color: #48465b;">${title}</h2>`;
		if (mensaje) texto += `<div style="font-weight: normal; font-size: 1.1rem; margin-top: 1.5rem;">${mensaje}</div>`;
		return Swal.fire({
			icon: 'question',
			html: texto,
			showCancelButton: true,
			confirmButtonColor: '#0abb87',
			cancelButtonColor: '#fd397a',
			confirmButtonText: 'Sí',
			cancelButtonText: 'No',
			onOpen: () => Swal.getCancelButton()?.focus(),
		});
	}

	//sweealert2
	getMessageSuccess(titulo: string, html: string) {
		return Swal.fire({
			icon: 'success',
			title: titulo,
			html: html,
			//text: mensaje,
		});
	}

	//toastr
	getSuccess(mensaje: string) {
		toastr.clear();
		toastr.options = {
			positionClass: 'toast-bottom-right',
			closeButton: true,
			progressBar: true,
			newestOnTop: true,
		};
		toastr['success'](mensaje, `<h5 class='text-white'></h5>`);
		return toastr;
	}

	getSuccessCRUD(interfaz: string, accion: TypeActionMessage | string) {
		toastr.clear();
		toastr.options = {
			positionClass: 'toast-bottom-right',
			closeButton: true,
			progressBar: true,
			newestOnTop: true,
		};
		var accionNombre = '';
		switch (accion) {
			case TypeActionMessage.REGISTRAR:
				accionNombre = 'registrado';
				break;
			case TypeActionMessage.MODIFICAR:
				accionNombre = 'modificado';
				break;
			case TypeActionMessage.ELIMINAR:
				accionNombre = 'eliminado';
				break;
			case TypeActionMessage.COPIAR:
				accionNombre = 'copiado';
				break;
			default:
				accionNombre = accion;
				break;
		}
		interfaz = `${interfaz} ${accionNombre} exitosamente.`;
		toastr['success'](interfaz);
		return toastr;
	}

	getFailMessage(mensaje: string) {
		return Swal.fire({
			icon: 'error',
			title: 'Error',
			text: mensaje,
		});
	}

	getMessageSuccessDelete(mensaje: string) {
		return Swal.fire({
			icon: 'success',
			title: 'Eliminación exitosa',
			text: mensaje,
		});
	}

	getMessageInfo(mensaje: string) {
		return Swal.fire({
			icon: 'info',
			title: 'Información',
			text: mensaje,
		});
	}

	getMessageSuccessTransmit(mensaje: string) {
		return Swal.fire({
			icon: 'success',
			title: 'Transmisión exitosa',
			text: mensaje,
		});
	}

	getMessageLoading(title: string, mensaje: string = '') {
		Swal.fire({
			title: `${title}`,
			html: `<h5 class="text-dark" style="font-family: Soho Gothic Pro;">${mensaje}<h5>`,
			text: mensaje,
			allowOutsideClick: false,
		});
		return Swal.showLoading();
	}

	closeLoading() {
		return Swal.close();
	}

	getNotResultSpanish() {
		return 'No existen resultados';
	}

	loadTable() {
		return `<span class="ag-overlay-loading-top d-flex align-items-center
		border-0 bg-white shadow p-4 text-info" style="height: 20px;">
		<img src="assets/media-demo/loading.gif"
		height="20" width="25" class="me-2"><strong>Cargando registros</strong></span>`;
	}
	loadTableIsBlank() {
		return `<span class="ag-overlay-loading-center border-0 bg-transparent">
		No existen Documentos Relacionados ...</span>`;
	}
	loadClassDisplayFlex(justifyContent: string, alignItems: string) {
		return `d-flex justify-content-${justifyContent} align-items-${alignItems}`;
	}
	/***
	 * ========================================================================
	 * TABLA WARNING
	 * ========================================================================
	 */

	getTableWarning(datos: any[], mensaje?: string, title: string = 'Advertencia') {
		function escapeHtml(unsafe) {
			return String(unsafe).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
		}

		function makeTableHTML(myArray) {
			var result = "<table class='table table-striped'>";
			for (var i = 0; i < myArray.length; i++) {
				result += '<tr>';
				for (var j = 0; j < myArray[i].length; j++) {
					let k = escapeHtml(myArray[i][j]);
					result += "<td style='text-align: left; font-size: 12px;'>" + k + '</td>';
				}
				result += '</tr>';
			}
			result += '</table>';
			return result;
		}
		if (datos.length > 0) {
			Object.keys(datos[0]).length;
			return Swal.fire({
				title: `<h5 style='font-size: 1.6rem;'>${title}</h5>`,
				html: `<h5 class="text-dark" style="font-family: Soho Gothic Pro; text-align: left; font-size: 1.1rem;">${mensaje}<h5>
				<div #table-clientes style="max-height: 16em !important; overflow-y: scroll !important;
				width: 100% !important;">${makeTableHTML(datos)}</div>`,
				showCancelButton: true,
				confirmButtonColor: '#0abb87',
				cancelButtonColor: '#5867dd',
				confirmButtonText: 'Aceptar',
				cancelButtonText: 'Exportar',
				allowOutsideClick: false,
				focusConfirm: true,
			});
		}
		return;
	}

	/***
	 * ========================================================================
	 * TOASTR ERROR
	 * ========================================================================
	 *
	 * @param mensaje - titulo
	 */
	alertError(mensaje: string, titulo: string = DefaultMessageText.ERROR) {
		this.toastrMensaje(mensaje, TypeMessage.ERROR, titulo);
	}
	private toastrMensaje(message: string, typeIcon: SweetAlertIcon, title: string) {
		if (toastr != null) toastr.remove();
		toastr.options = {
			positionClass: ToastrPosition.BOTTON_RIGHT,
			closeButton: true,
			progressBar: true,
			newestOnTop: true,
			timeOut: 8000,
		};
		if (typeof title === 'undefined' || title == null) {
			toastr[typeIcon](message);
		} else {
			toastr[typeIcon](message, `<h5 class='text-white'> ${title.toUpperCase()} </h5>`);
		}
		return toastr;
	}
}
